import React, { useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useMediaQuery } from "react-responsive"
import { Link } from "react-router-dom"
import classNames from "classnames"

import { authProtectedRoutes } from "routes"
import useAuthorization from "hooks/useAuthorization"

import "./navbar.scss"

// Misma normalización que useAuthorization.permisoDe: el route del menú viene
// del objRoute del objeto de permiso ("/agro/alta-productor").
const normalizarRuta = ruta => (ruta || "").replace(/^\//, "").toLowerCase()

// BDSJEA-239: pantallas que solo tienen sentido con modificación (altas). Se
// derivan de routes/index.js, única fuente de verdad. Solo cuentan las rutas
// auto-referenciadas (el objeto de permiso es la pantalla misma): un objeto
// compartido como /agro/busqueda/productor lo usan también rutas de consulta
// (Búsqueda de Productor, Evaluaciones), y no hay que ocultarlas.
const RUTAS_QUE_REQUIEREN_MODIFICACION = new Set(
  authProtectedRoutes
    .filter(
      r => r.accionRequerida === "modificacion" && r.objetoRequerido === r.path,
    )
    .map(r => normalizarRuta(r.objetoRequerido)),
)

const requiereModificacionParaVerse = ruta =>
  RUTAS_QUE_REQUIEREN_MODIFICACION.has(normalizarRuta(ruta))

const NavbarItems = props => {
  const [active, setActive] = useState(false)
  const { item, dropdown } = props
  const { puedeModificarObjeto } = useAuthorization()

  const isBigScreen = useMediaQuery({ query: "(min-width: 992px)" })

  // BDSJEA-239: el backend agrega el hijo si el usuario tiene consulta O
  // modificación (PerfilManager.getChilds); acá se ocultan las pantallas que
  // exigen modificación cuando el usuario no la tiene sobre ese objeto.
  const childsVisibles = useMemo(
    () =>
      item.childs.filter(
        child =>
          !requiereModificacionParaVerse(child.route) ||
          puedeModificarObjeto(child.route),
      ),
    [item.childs, puedeModificarObjeto],
  )

  return (
    <>
      <div
        style={{ cursor: "pointer" }}
        className={classNames(`${dropdown} dropdown-toggle arrow-none`, {
          active: active,
          "no-active": !active,
          "text-black": !isBigScreen,
        })}
        onClick={e => {
          if (!isBigScreen) {
            e.preventDefault()
            props.toggleTodo(item.order)
          }
        }}
        onMouseEnter={() => setActive(true)}
        onMouseLeave={() => setActive(false)}
      >
        {item.name} {props.menuOpen}
        {!!childsVisibles.length && <div className="arrow-down"></div>}
      </div>
      {!!childsVisibles.length && (
        <div
          className={classNames("dropdown-menu", { show: item.show })}
          onMouseEnter={() => setActive(true)}
          onMouseLeave={() => setActive(false)}
        >
          {childsVisibles.map((item, key) => (
            <Childs {...props} item={item} key={key} />
          ))}
        </div>
      )}
    </>
  )
}

const Child = ({ item }) => {
  return (
    <Link to={item.route} className="dropdown-item">
      {item.name}
    </Link>
  )
}

const Childs = props => {
  const { item } = props

  if (item.childs.length === 0) {
    return <Child item={item} />
  } else {
    return (
      <div className="dropdown">
        <NavbarItems {...props} dropdown={"dropdown-item"} />
      </div>
    )
  }
}

NavbarItems.propTypes = {
  toggleTodo: PropTypes.func,
  dropdown: PropTypes.string,
  item: PropTypes.any,
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

export default NavbarItems
